import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// APIs
import useFetchData from "../../API/useFetchData.js";
import useFetchMedia from "../../API/useGetMedia.js";
import useCreateData from "../../API/useCreateData.js";
import useDeleteImages from "../../API/useDeleteImages.js";
// Styles
import Masonry from "react-masonry-css";
// Components
import Sidebar from "../../Components/Sidebar/Sidebar.jsx";
import ConfirmMessage from "../../Components/ConfirmationMessage/ConfirmMessage.jsx";
import LoadingComponent from "../../Components/LoadingComponent/LoadingComponent.jsx";
// Material UI
import Checkbox from "@mui/material/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
// Store
import { usePhotos } from "../../Redux/PhotosContext.js";
import {
  Button,
  SelectAll,
  // Logout, TODO:: use later
} from "../../Components/Sidebar/SidebarStyles.js";
import SuccessCard from "../../Components/MessageAfterAction/Card.jsx";
import FalseCard from "../../Components/MessageAfterAction/FalseCard.jsx";
const Gallery = () => {
  const navigate = useNavigate();
  // APIs
  const { fetchData } = useFetchData("/manager/photos");
  const { fetchMedia } = useFetchMedia();
  const { createData } = useCreateData(
    "/manager/photos/approve",
    "photos accepeted successfully",
    "Error accepting photos"
  );
  const { deleteItem } = useDeleteImages();
  // States
  const {
    photos,
    setPhotos,
    Entered,
    setIsEntered,
    originalImages,
    setOriginalImages,
    originalImagesLogo,
    setOriginalImagesLogo,
    toApprovePhotos,
    setToApprovePhotos,
  } = usePhotos();
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [click, setClick] = useState(false);
  const [isSidebar, setIsSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [expandedPhotoId, setExpandedPhotoId] = useState(null);
  const [loadingPhotoIds, setLoadingPhotoIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuccessCard, setShowSuccessCard] = useState(false);
  const [showFalseCard, setShowFalseCard] = useState(false);
  const [status, setStatus] = useState("Accepted");
  useEffect(() => {
    if (!Entered && !loading) {
      const loadPhotos = async () => {
        setLoading(true);
        try {
          const response = await fetchData({ approved: "false" });

          const imageMap = {};
          // Fetch media URLs one by one and update the photos state
          for (const photo of response) {
            const media = await fetchMedia(photo.photoUrl);
            setPhotos((prevPhotos) => [
              ...prevPhotos,
              {
                id: photo.id,
                url: media,
                uploadedBy: photo.uploadedBy,
                approved: photo.approved,
                createdAt: photo.createdAt,
                updatedAt: photo.updatedAt,
                className: photo.className,
                yearName: photo.yearName,
              },
            ]);
            imageMap[photo.id] = media.url;
          }

          setOriginalImages(imageMap);
        } catch (error) {
          console.log("Error fetching photos:", error);
        }
        setLoading(false);
        setIsEntered(true);
      };

      loadPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActionClick = (type) => {
    if (selectedPhotos.length === 0) {
      return;
    }
    setActionType(type);
    setShowModal(true);
  };

  const toggleSelectPhoto = (photo) => {
    if (selectedPhotos.includes(photo.id)) {
      setSelectedPhotos(selectedPhotos.filter((id) => id !== photo.id));
    } else {
      setSelectedPhotos([...selectedPhotos, photo.id]);
    }
  };

  const handleImageClick = (id, startindex) => {
    // store index in local storage
    localStorage.setItem("index", startindex);
    navigate("/ImageView");
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedPhotos([]);
    } else {
      setSelectedPhotos(photos.map((photo) => photo.id));
    }
    setSelectAll(!selectAll);
  };

  const handleAcceptPhotos = async () => {
    const idsToAccept = [...selectedPhotos];

    if (idsToAccept.length === 0) {
      console.log("No photos selected to accept");
      return;
    }
    const acceptData = idsToAccept.map((id) => {
      return toApprovePhotos.find((p) => p.photoId === id) || { photoId: id };
    });

    try {
      // Call the API with the list of IDs
      await createData(acceptData).then(() => {
        console.log("Photos accepted successfully");
        setPhotos((prevPhotos) =>
          prevPhotos.filter((photo) => !idsToAccept.includes(photo.id))
        );
        setToApprovePhotos((prevPhotos) =>
          prevPhotos.filter((photo) => !idsToAccept.includes(photo.photoId))
        );

        setShowSuccessCard(true);
        setStatus("Accepted");
      });
    } catch (error) {
      setShowFalseCard(true);
      setStatus("Accepted");
      console.log("Error accepting photos:", error);
    }
  };
  console.log(showSuccessCard);
  const handleDeletePhotos = async () => {
    const idsToDelete = [...selectedPhotos];

    if (idsToDelete.length === 0) {
      console.log("No photos selected to accept");
      return;
    }

    try {
      // Call the API with the list of IDs
      const endpoint = "/manager/photos";
      await deleteItem(endpoint, idsToDelete);
      setPhotos((prevPhotos) =>
        prevPhotos.filter((photo) => !idsToDelete.includes(photo.id))
      );
      setToApprovePhotos((prevPhotos) =>
        prevPhotos.filter((photo) => !idsToDelete.includes(photo.photoId))
      );
      setShowSuccessCard(true);
      setStatus("Deleted");
    } catch (error) {
      setShowFalseCard(true);
      setStatus("Deleted");
      console.log("Error accepting photos:", error);
    }
  };

  const handleConfirmAction = async () => {
    try {
      if (actionType === "accept") {
        await handleAcceptPhotos();
      } else if (actionType === "delete") {
        await handleDeletePhotos();
      } else if (actionType === "reset") {
        if (originalImages.length !== 0 || originalImagesLogo.length !== 0) {
          setPhotos((prevPhotos) =>
            prevPhotos.map((photo) => {
              if (selectedPhotos.includes(photo.id)) {
                return {
                  ...photo,
                  url: {
                    ...photo.url, // Keep other properties of the 'url' object
                    url: originalImages[photo.id], // Update only the 'url' field
                  },
                  logoAdded: false, // Reset the logoAdded property
                };
              }
              return photo;
            })
          );
          setOriginalImagesLogo([]);
        }
      }
      setSelectedPhotos([]);
      setShowModal(false);
    } catch (err) {
      console.log("An error occurred. Please try again.", err);
    }
  };
  const handleClick = () => setClick(!click);

  const handleCancelAction = () => setShowModal(false);

  const handleOkClick = () => {
    setShowSuccessCard(false); // Close the success card
    setShowFalseCard(false);
  };
  const toggleExpandPhoto = (photo) =>
    setExpandedPhotoId((prevId) => (prevId === photo.id ? null : photo.id));

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <div className="App" sx={{ overFlow: "auto" }}>
      <div
        className="App"
        sx={{
          overFlow: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {photos.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Center vertically in full view height
              fontSize: "24px", // Adjust font size as needed
              color: "rgba(255, 255, 255, 1)", // Adjust text color as needed
            }}
          >
            There are no pending images left.
          </div>
        ) : (
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {photos.map((photo) => (
              <div key={photo.id}>
                <div
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {click && (
                    <Checkbox
                      checked={selectedPhotos.includes(photo.id)}
                      onChange={() => toggleSelectPhoto(photo)}
                      sx={{
                        position: "absolute",
                        top: "40px",
                        left: "5px",
                        zIndex: 1,
                        transform: "scale(2.0)", // Scale the checkbox to make it bigger
                        cursor: "pointer",
                        color: "rgba(0, 0, 0, 0.7)", // Checkbox color when unchecked
                        "&.Mui-checked": {
                          color: "rgba(0, 0, 0, 0.7)", // Checkbox color when checked
                        },
                      }}
                    />
                  )}
                  <InfoIcon
                    onClick={() => toggleExpandPhoto(photo)}
                    fontSize="large"
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      cursor: "pointer",
                      zIndex: 1,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                  />
                  <div
                    className="image-container"
                    onClick={() => {
                      if (click) {
                        toggleSelectPhoto(photo);
                      } else {
                        handleImageClick(photo.id, photos.indexOf(photo));
                      }
                    }}
                  >
                    <img
                      alt={""}
                      src={photo.url.url}
                      style={{
                        width: "100%",
                        display: "block",
                        borderRadius: "10px",
                        filter:
                          loadingPhotoIds && loadingPhotoIds.includes(photo.id)
                            ? "blur(10px)"
                            : "none",
                        transition: "filter 0.3s ease",
                      }}
                    />
                  </div>
                  {expandedPhotoId === photo.id && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        right: "0",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        padding: "10px",
                        borderRadius: "0 0 10px 10px",
                        zIndex: 2,
                      }}
                    >
                      <p style={{ color: "white" }}>
                        Uploaded By: {photo.uploadedBy}
                      </p>
                      <p style={{ color: "white" }}>
                        Created At: {new Date(photo.createdAt).toLocaleString()}
                      </p>
                      <p style={{ color: "white" }}>
                        Updated At: {new Date(photo.updatedAt).toLocaleString()}
                      </p>
                      <p style={{ color: "white" }}>
                        Class Name: {photo.className}
                      </p>
                      <p style={{ color: "white" }}>
                        Year Name: {photo.yearName}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
            {loading && (
              <div
                key={0}
                style={{
                  position: "relative",
                  marginBottom: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <LoadingComponent size="40%" thickness={4} color="neutral" />
              </div>
            )}
          </Masonry>
        )}
        {photos.length !== 0 && (
          <Button clicked={click} onClick={() => handleClick()}>
            {click ? "Done" : ""}
          </Button>
        )}
        {click && photos.length !== 0 && (
          <SelectAll onClick={() => handleSelectAll()}>
            {!selectAll ? (
              <>
                Select All <DoneAllIcon style={{ marginLeft: "0.5rem" }} />
              </>
            ) : (
              <>
                Clear All <RemoveDoneIcon style={{ marginLeft: "0.5rem" }} />
              </>
            )}
          </SelectAll>
        )}
        {click && photos.length !== 0 && (
          <Sidebar
            isSidebar={isSidebar}
            setIsSidebar={setIsSidebar}
            handleActionClick={handleActionClick}
            photos={photos}
            setAllPhotos={setPhotos}
            selectedPhotos={selectedPhotos}
            loadingPhotoIds={loadingPhotoIds}
            setLoadingPhotoIds={setLoadingPhotoIds}
            handleSelectAll={handleSelectAll}
            setAcceptedPhotos={setToApprovePhotos}
            originalImages={originalImages}
            setOriginalImages={setOriginalImages}
            originalImagesLogo={originalImagesLogo}
            setOriginalImagesLogo={setOriginalImagesLogo}
          />
        )}

        <ConfirmMessage
          showModal={showModal}
          actionType={actionType}
          handleConfirmAction={handleConfirmAction}
          handleCancelAction={handleCancelAction}
          selectedPhotos={selectedPhotos}
          AllPhotos={photos}
        />

        {showSuccessCard && (
          <SuccessCard onClose={handleOkClick} status={status} />
        )}
        {showFalseCard && <FalseCard onClose={handleOkClick} status={status} />}
      </div>
    </div>
  );
};

export default Gallery;
